import { X, Leaf, Package, Info, ShoppingCart } from 'lucide-react'
import { getImageUrl } from '../utils/imageHelper'

const ProductModal = ({ product, isOpen, onClose }) => {
  if (!isOpen || !product) return null

  const {
    name,
    image,
    shortDesc,
    fullDesc,
    npk,
    npk_n,
    npk_p,
    npk_k,
    micros,
    price,
    sizes,
    category,
    usageInstructions
  } = product

  // Handle both npk object and separate npk_n, npk_p, npk_k fields
  const nitrogen = npk?.n ?? npk_n ?? 0
  const phosphorus = npk?.p ?? npk_p ?? 0
  const potassium = npk?.k ?? npk_k ?? 0

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" onClick={onClose}>
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" aria-hidden="true"></div>

        {/* Center modal */}
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        {/* Modal panel */}
        <div
          className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 bg-white rounded-full p-2 hover:bg-gray-100 transition-colors shadow-lg"
          >
            <X className="h-6 w-6 text-gray-600" />
          </button>

          <div className="bg-white">
            {/* Product Image Section */}
            <div className="relative h-80 overflow-hidden">
              <img
                src={getImageUrl(image)}
                alt={name}
                className="w-full h-full"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-earth-green text-white px-4 py-2 rounded-full text-sm font-medium capitalize shadow-lg">
                  {category}
                </span>
              </div>
            </div>

            {/* Product Details Section */}
            <div className="p-8">
              {/* Product Title */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <h2 className="text-3xl font-bold text-gray-900 mb-2">{name}</h2>
                </div>
                <div className="ml-4">
                  <Leaf className="h-10 w-10 text-earth-green" />
                </div>
              </div>



              {/* Full Description */}
              <div className="mb-6">
                <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
                  <Info className="h-5 w-5 mr-2 text-earth-green" />
                  Product Description
                </h3>
                <p className="text-gray-600 leading-relaxed">{fullDesc}</p>
              </div>

              {/* Micronutrients */}
              {micros && micros.length > 0 && (
                <div className="mb-6">
                  <h3 className="font-semibold text-gray-900 mb-3">Micronutrients</h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                    {micros.map((micro, index) => (
                      <div key={index} className="bg-gray-50 rounded-lg p-3">
                        <div className="text-sm font-medium text-gray-900">{micro.name}</div>
                        <div className="text-xs text-gray-600">{micro.percentage}%</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductModal

